import { takeLatest } from "redux-saga/effects";
import { FETCH_VACATION_RENTAL_SHOP, CHECK_LIFESTYLE_ELIGIBILITY } from "../actions/constants";
import fetchVacationRentalShopSaga from "./fetchVacationRentalShopSaga";
import checkLifestyleEligibilitySaga from "./checkLifestyleEligibilitySaga";

export function* watchFetchVacationRentalShopSaga() {
  yield takeLatest(FETCH_VACATION_RENTAL_SHOP, fetchVacationRentalShopSaga);
}

export function* watchCheckLifestyleEligibilitySaga() {
  yield takeLatest(CHECK_LIFESTYLE_ELIGIBILITY, checkLifestyleEligibilitySaga);
}
